import {comMapping} from "../../../../../../util/Function/comMapping";

export function getdata() {
    let obj = {
        headData: [
            {
                title: "获取时间",
                prop: "getTime",
                width: 80,
                custom: true
            },
            {
                title: "公司代码",
                prop: "companyCode",
                width: 80,
                custom: true
            },
            {
                title: "公司名称",
                prop: "companyName",
                custom: true,
                width: 80,
            },
            {
                title: "公司税号",
                prop: "nsrsbh",
                width: 120,
                custom: true
            },
            {
                title: "发票所属期",
                prop: "suosq",
                width: 110,
                custom: true
            },
            {
                title: "分摊方式",
                prop: "fentfs",
                width: 80,
                custom: true
            },
            {
                title: "销售总额",
                prop: "xiaosze",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "即征即退销售总额",
                prop: "jzjtxiaosze",
                width: 130,
                AmountFormat: true,
                custom: true
            },
            {
                title: "分摊比例",
                prop: "fentbl",
                width: 80,
                custom: true
            },
            {
                title: "获取结果",
                prop: "result",
                width: 80,
                custom: true
            },
        ]
    };
    return obj
}
